import React, { useRef, useContext } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { AiOutlineUpload } from 'react-icons/ai';
import { useFileExploreContext } from 'hooks/useFileExplore';
import LocaleContext from 'locales';
import useUpload from 'hooks/useUpload';

const Upload = () => {
  const fileInputRef = useRef(null);
  const folderInputRef = useRef(null);

  const { locale } = useContext(LocaleContext);

  // 파일 탐색기 컨텍스트에서 현재 경로와 드라이브 정보 가져오기
  const { state } = useFileExploreContext();
  const { currentPath, selectedDrive } = state;

  // 업로드 컨텍스트에서 파일 추가 메서드 가져오기
  const { addFiles, toggleVisibility } = useUpload({
    userId: localStorage.getItem('userId'),
    userName: localStorage.getItem('username'),
  });

  // 파일 선택 처리
  const handleFileInputChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      addFiles(files, currentPath, selectedDrive, false);
      toggleVisibility(true);
    }
    e.target.value = null;
  };

  // 폴더 선택 처리
  const handleFolderInputChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      addFiles(files, currentPath, selectedDrive, true);
      toggleVisibility(true);
    }
    e.target.value = null;
  };

  // 드롭다운 메뉴 설정
  const menu = (
    <Menu>
      <Menu.Item key="file" onClick={() => fileInputRef.current.click()}>
        {locale.resource['txt.file-transfer.upload-file']}
      </Menu.Item>
      <Menu.Item key="folder" onClick={() => folderInputRef.current.click()}>
        {locale.resource['txt.file-transfer.upload-folder']}
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown disabled={!selectedDrive} overlay={menu} placement="bottomLeft">
        <Button type="text" icon={<AiOutlineUpload className="anticon" />}>
          {locale.resource['txt.file-transfer.upload']}
        </Button>
      </Dropdown>

      {/* 파일 입력 (숨김) */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        multiple
        onChange={handleFileInputChange}
      />

      {/* 폴더 입력 (숨김) */}
      <input
        type="file"
        ref={folderInputRef}
        style={{ display: 'none' }}
        directory=""
        webkitdirectory=""
        onChange={handleFolderInputChange}
      />
    </>
  );
};

export default Upload;
